var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentsOffBorded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M34.9951 0C43.2793 0.000108261 49.9951 6.7158 49.9951 15V35C49.9951 43.2842 43.2793 49.9999 34.9951 50H15C6.71573 50 3.22156e-07 43.2843 0 35V15C3.22155e-07 6.71573 6.71573 0 15 0H34.9951Z",
    fill: "#5E81F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M32.4948 19.667C34.566 19.667 36.2458 21.4579 36.2458 23.667C36.2455 25.8759 34.5658 27.667 32.4948 27.667C30.424 27.6668 28.7451 25.8758 28.7448 23.667C28.7448 21.458 30.4238 19.6672 32.4948 19.667ZM21.2477 13C24.0092 13 26.2486 15.3876 26.2487 18.333C26.2487 21.2785 24.0093 23.667 21.2477 23.667C18.4864 23.6667 16.2477 21.2784 16.2477 18.333C16.2479 15.3878 18.4865 13.0002 21.2477 13Z",
    fill: "#5E81F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2235 26.3335C27.2079 26.3335 32.1247 29.391 32.4911 35.9331C32.5057 36.1937 32.4915 37.0004 31.5526 37.0005H10.9042C10.5906 36.9998 9.96961 36.2786 9.99599 35.9321C10.4806 29.5689 15.3223 26.3336 21.2235 26.3335ZM31.997 29.0024C36.2549 29.052 39.7313 31.3467 39.9931 36.1997C40.0036 36.3952 39.9935 37.0005 39.3153 37.0005H34.495C34.495 33.9997 33.5654 31.2306 31.997 29.0024Z",
    fill: "#5E81F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsOffBorded);
export default __webpack_public_path__ + "static/media/StudentsOffBorded.14898c2ab07d1cda49be5382afa371d4.svg";
export { ForwardRef as ReactComponent };